import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setCustomerName } from '../../../store/slices/customerSlice';
import './Customers.css';
import Button from '../../../components/Button/Button';
import Table from '../../../components/Table/Table';
import Dropdown from '../../../components/Dropdown/Dropdown';
import Filters from '../../../components/Filters/Filters';
import ModalAlert from '../../../components/ModalAlert/ModalAlert';
import Modal from '../../../components/Modal/Modal';
//icons
import editIcon from '../../../assets/editIcon.png';
import editInactive from '../../../assets/tokens/editInactive.png';
import eyeOn from '../../../assets/tokens/eyeOn.png';
import eyeOff from '../../../assets/tokens/eyeOff.png';
import toggleActive from '../../../assets/toggleActive.png';
import toggleInactive from '../../../assets/toggleInactive.png';
import trashActive from '../../../assets/tokens/trashActive.png';
import trashInactive from '../../../assets/tokens/trashInactive.png';
import startActive from '../../../assets/tokens/startActive.png';
import startInactive from '../../../assets/tokens/startInactive.png';
//services
import { customer } from '../../../services/customer';
import { modulePermissions } from '../../../utils/modulePermissions';
//utils
import { formatDate } from '../../../utils/utils';
import Tooltip from '../../../components/Tooltip/Tooltip';

const Customers = () => {
  const navigate = useNavigate();
  const { searchTerm } = useSelector((state) => state.search);
  const [selectedCustomerType, setSelectedCustomerType] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isCustomerFilter, setIsCustomerFilter] = useState(false);
  const [isStatusFilter, setIsStatusFilter] = useState(false);
  const [isModalAlert, setIsModalAlert] = useState(false);
  const [error, setError] = useState(false);
  const [titleAlert, setTitleAlert] = useState({ text: '', highlight: '' });
  const [messageAlert, setMessageAlert] = useState('');
  const [title, setTitle] = useState({ text: '', highlight: '' });
  const [message, setMessage] = useState('');
  const [isModalMessage, setIsModalMessage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [customersData, setCustomersData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [option, setOption] = useState('');
  const [columnsShare, setColumnsShare] = useState(0);

  const AlertToggle = (row) => {
    setSelectedRow(row);
    setOption('toggle');
    const title = row.status === 'Active' ? 'Disable' : 'Enable';
    setTitleAlert({ text: title, highlight: 'customer' });
    setMessageAlert('Do you want to continue with the action?');
    setIsModalAlert(!isModalAlert);
  };

  const handleToggle = async () => {
    try {
      const status = selectedRow.status === 'Active' ? 'disabled' : 'active';
      const title = selectedRow.status === 'Active' ? 'disable' : 'enable';
      const message = selectedRow.status === 'Active' ? 'The client is now disabled' : 'The client is now enabled';
      const response = await customer.toggleStatus(selectedRow.id, status);
      if (response.status === 'success') {
        setTitle({ text: 'Client successfully ', highlight: title });
        setMessage(message);
        setError(false);
        setIsModalMessage(true);
        fetchCustomers(selectedCustomerType, selectedStatus, currentPage);
      }
    } catch (error) {
      const title = selectedRow.status === 'Active' ? 'disabling' : 'enabling';
      setTitle({ text: 'Error to ', highlight: title });
      setMessage('Failed to update customer status');
      setError(true);
      setIsModalMessage(true);
    }
  };

  const AlertDelete = (row) => {
    if(row.status === 'Active') {
      setSelectedRow(row);
      setOption('delete');
      setTitleAlert({ text: 'Delete', highlight: 'customer' });
      setMessageAlert('Do you want to continue with the action?');
      setIsModalAlert(!isModalAlert);
    }else{
      alertIsDisabled();
    }
  };

  const handleDelete = async () => {
    try {
      const response = await customer.delete(selectedRow.id);
      if(response.status === 'success') {
        setTitle({ text: 'Client successfully ', highlight: 'deleted' });
        setMessage('Client deleted successfully');
        setError(false);
        setIsModalMessage(true);
        fetchCustomers(selectedCustomerType, selectedStatus, currentPage);
      }
    } catch (error) {
      setTitle({ text: 'Error to ', highlight: 'delete' });
      setMessage('Failed to delete client');
      setError(true);
      setIsModalMessage(true);
    }
  };

  const handleOptionAlert = () => {
    setIsModalAlert(false);
    console.log(option);
    switch (option) {
      case 'toggle':
        handleToggle();
        break;
      case 'delete':
        handleDelete();
        break;
      default:
        break;
    }
  };

  const alertIsDisabled = () => {
    setTitle({ text: 'Error ', highlight: 'Action' });
    setMessage('Client disabled, action unavailable');
    setError(true);
    setIsModalMessage(true);
  };

  useEffect(() => {
    fetchColumns();
    fetchCustomers();
  }, [selectedStatus, selectedCustomerType, searchTerm, currentPage]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchCustomers(selectedStatus, selectedCustomerType, searchTerm, currentPage);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, selectedStatus, selectedCustomerType, currentPage]);

  const fetchColumns = () => {
    const columnsCurrentUser = [
      { header: 'Client´s name', field: 'name' },
      { header: 'E-mail', field: 'email' },
      { header: 'Qualification', render: (row) => (
        <div className="edit-btn">
          {row.qualification}
          <img src={startActive} alt="Start" />
        </div>
      )},
      { header: 'Telephone', field: 'telephone' },
      { header: 'Date of birth', field: 'dateOfBirth' },
      { header: 'Gender', field: 'gender' },
      { header: 'Status', field: 'status' }
    ];

    let count = columnsShare;

    if(modulePermissions.hasClientTabPermission()) {
      columnsCurrentUser.push({
        header: '',
        render: (row) => (
          <Tooltip text="View details of this customer">
            <button className="edit-btn" onClick={() => handleView(row)}>
              <img src={eyeOn} alt="View" />
            </button>
          </Tooltip>
        )
      });
      count++;
    }

    if(modulePermissions.hasClientManagementPermission('activate_deactivate')) {
      columnsCurrentUser.push({
        header: '',
        render: (row) => (
          <Tooltip text="Disable or Enable this customer">
            <button className="edit-btn" onClick={() => AlertToggle(row)}>
              <img src={row.status === 'Active' ? toggleActive : toggleInactive} alt="Toggle" />
            </button>
          </Tooltip>
        )
      });
      count++;
    }

    if(modulePermissions.hasClientManagementPermission('delete')) {
      columnsCurrentUser.push({
        header: '',
        render: (row) => (
          <Tooltip text="Delete this customer">
            <button className="edit-btn" onClick={() => AlertDelete(row)}>
              <img src={row.status === 'Active' ? trashActive : trashInactive} alt="Delete" />
            </button>
          </Tooltip>
        )
      });
      count++;
    }

    setColumns(columnsCurrentUser);
    setColumnsShare(count);
  };

  const handleDownload = () => {
    try {
      const params = {
        ...(searchTerm && { query: searchTerm }),
        ...(selectedCustomerType && { type: selectedCustomerType }),
        ...(selectedStatus && { status: selectedStatus })
      };
      customer.download(params);
    } catch (error) {
      console.error('Error downloading customers:', error);
    }
  };

  const fetchCustomers = async (status = '', type = '', search = '', page = 1) => {
    try {
      const params = {
        page: page,
        items_per_page: 10,
        ...(status && { status }),
        ...(type && { type }),
        ...(search && {search })
      };
      const response = await customer.getList(params);
      if(response.status === "success") {
        setTotalItems(response.data.total);
        const customers = response.data.data.map(customer => ({
          ...customer,
          qualification: customer.is_customer ? customer.profile.customer_rating : customer.profile.supplier_rating,
          telephone: customer.phone,
          status: customer.status === 'active' ? 'Active' : 'Inactive',
          dateOfBirth: customer.profile.birthdate ? formatDate(customer.profile.birthdate) : null,
          gender: customer.profile.gender
        }));
        setCustomersData(customers);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const dispatch = useDispatch();

  const handleView = (row) => {
    dispatch(setCustomerName(row.name));
    navigate(`/customers/info-customer/${row.id}`, {
      state: { customer: row }
    });
  };

  return (
    <div className="customers-page">
      <div className="customers-container">
        <div className="actions-bar">
          <div className="content-filter">
            <Filters
              filters={[
                {
                  id: 'type',
                  label: 'Customer type',
                  type: 'checkbox',
                  options: ['Customer', 'Supplier'] 
                },
                {
                  id: 'status',
                  label: 'Status',
                  type: 'checkbox',
                  options: ['Active', 'Inactive'] 
                }
              ]}
              onApplyFilters={(filters) => {
                console.log('Applying filters:', filters);
                if(filters.type) {
                  setSelectedCustomerType(filters.type.toLowerCase() || '');
                }else{
                  setSelectedCustomerType('');
                }
                setSelectedStatus('');
                if(filters.status === 'Inactive') {
                  setSelectedStatus('disabled');
                } else if (filters.status === 'Active') {
                  setSelectedStatus('active');
                }
              }}
            />
          </div>
          <div className="action-buttons">
            {modulePermissions.hasClientManagementPermission('download') && (
              <Button
                onClick={() => handleDownload()}
                variant="warning"
                borderRadius={6}
              >
                Download
              </Button>
            )}
          </div>
        </div>

        <Table
          columns={columns}
          data={customersData}
          columnsShare={columnsShare}
          itemsPerPage={10}
          currentPage={currentPage}
          totalItems={totalItems}
          onPageChange={(page) => {
            setCurrentPage(page);
            fetchCustomers(selectedStatus, selectedCustomerType, searchTerm, page);
          }}
          headerBackground="var(--color-primary)"
          headerTextColor="var(--color-white)"
        />

        <ModalAlert
          isOpen={isModalAlert}
          onClose={() => setIsModalAlert(false)}
          title={titleAlert}
          message={messageAlert}
          acecept={true}
          onAccept={handleOptionAlert}
        />
        <Modal
          isOpen={isModalMessage}
          onClose={() => setIsModalMessage(false)}
          title={title}
          message={message}
          error={error}
          onConfirm={() => setIsModalMessage(false)}
        />
      </div>
    </div>
  );
};

export default Customers;
